import { lazy } from "react";

export const PageAdminLogin = lazy(() => import("./Container"));
